var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusRadial = function SvgPlusRadial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23C6.71 23 2 18.29 2 12.5S6.71 2 12.5 2 23 6.71 23 12.5 18.29 23 12.5 23Zm0-19.32c-4.864 0-8.82 3.956-8.82 8.82 0 4.864 3.956 8.82 8.82 8.82 4.864 0 8.82-3.957 8.82-8.82s-3.956-8.82-8.82-8.82Z",
    fill: "#58B847",
    stroke: "#58B847",
    strokeWidth: 0.371
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.059a.794.794 0 0 1-.794-.794v-9.53a.794.794 0 0 1 1.588 0v9.53a.794.794 0 0 1-.794.794Z",
    fill: "#58B847",
    stroke: "#58B847",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.265 13.294h-9.53a.794.794 0 1 1 0-1.588h9.53a.794.794 0 0 1 0 1.588Z",
    fill: "#58B847",
    stroke: "#58B847",
    strokeWidth: 0.2
  })));
};
export default SvgPlusRadial;